<button
  *ngIf="!loggedinB2C"
  (click)="OnLoginClick($event)"
  class="matero-toolbar-button matero-avatar-button"
  mat-button
  class="sidebar-button"
>
  <span>LOGIN</span>
</button>

<button
  *ngIf="loggedinB2C"
  class="matero-toolbar-button matero-avatar-button"
  mat-button
  [matMenuTriggerFor]="menu"
>
  <mat-icon>account_circle</mat-icon>
  <span class="matero-username" fxHide.lt-sm>{{ accountDisplayName }}</span>
</button>

<mat-menu #menu="matMenu">
  <button (click)="OnLogoutClick($event)" mat-menu-item>
    <mat-icon>logout</mat-icon>
    <span>{{ 'profile.logout' | translate }}</span>
  </button>
</mat-menu>
